import { render, staticRenderFns } from "./ContactCreateModal.vue?vue&type=template&id=036606f2"
import script from "./ContactCreateModal.vue?vue&type=script&lang=js"
export * from "./ContactCreateModal.vue?vue&type=script&lang=js"
import style0 from "./ContactCreateModal.vue?vue&type=style&index=0&id=036606f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports